import { gql } from "graphql-request";

export const GET_ALL_REPORTS = gql`
  query GetAllReports(
    $reportType: String
    $adjustmentType: String
    $clientId: String
    $tenantId: String
    $pageNo: Int
    $pageSize: Int
    $startDate: String
    $endDate: String
    $onlyAdjustments: Boolean
    $onlyExports: Boolean
  ) {
    getAllReports(
      reportType: $reportType
      adjustmentType: $adjustmentType
      clientId: $clientId
      tenantId: $tenantId
      pageNo: $pageNo
      pageSize: $pageSize
      startDate: $startDate
      endDate: $endDate
      onlyAdjustments: $onlyAdjustments
      onlyExports: $onlyExports
    ) {
      data {
        _id
        result
        entryCount
        estimatedDuties
        effectiveDutyRate
        changeInGoodsValue
        changeInDutyAmount
        stepsCompleted
        createdAt
        selectedOptions
        isCompleted
        reportType
        fileId
        s3Key
        exportDate
        exportDateAbbrev
      }
      meta {
        countDocs
      }
    }
  }
`;

export const GET_RECONCILATION_AMOUNT = gql`
  query GetTotalSumReconciliation(
    $currency: String!
    $clientId: String
    $tenantId: String
    $dateTo: Int
    $dateFrom: Int
    $filters: ReconciliationFiltersInput
  ) {
    getTotalSumReconciliation(
      currency: $currency
      clientId: $clientId
      tenantId: $tenantId
      dateTo: $dateTo
      dateFrom: $dateFrom
      filters: $filters
    ) {
      totalAmount
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation CreateReport($report: ReportInput!, $clientId: String, $tenantId: String) {
    createReport(report: $report, clientId: $clientId, tenantId: $tenantId) {
      data
    }
  }
`;

export const DELETE_REPORT = gql`
  mutation DeleteReport($id: ID!) {
    deleteReport(_id: $id) {
      data
    }
  }
`;

export const INVOKE_LAMBDA_FUNCTION = gql`
  mutation InvokeLambdaFunction($input: InvokeLambdaInput!) {
    invokeLambdaFunction(input: $input) {
      progressBar
      signedUrl
      fileId
    }
  }
`;

export const GET_REPORT_DOWNLOAD_STATUS = gql`
  query GetDownload($input: DownloadQueryInput!) {
    getDownload(input: $input) {
      msg
      url
      status
      progress
    }
  }
`;

export const PREVIEW_RECONCILIATION = gql`
  mutation PreviewReconciliation($input: ReconciliationInput!) {
    previewReconciliation(input: $input) {
      recordCount
      adjustmentSummary
      affectedFields
      estimatedProcessingTime
    }
  }
`;

export const PROCESS_RECONCILIATION = gql`
  mutation ProcessReconciliation($input: ReconciliationInput!) {
    processReconciliation(input: $input) {
      fileId
      progressBar
      signedUrl
      adjustmentType
    }
  }
`;

export const GET_HTS_CODES_FOR_DROPDOWN = gql`
  query GetHTSCodesForDropdown($clientId: String, $tenantId: String, $includeChapter99: Boolean) {
    getHTSCodesForDropdown(
      clientId: $clientId
      tenantId: $tenantId
      includeChapter99: $includeChapter99
    ) {
      data {
        value
        label
        type
      }
    }
  }
`;

export const GET_COUNTRIES_FOR_DROPDOWN = gql`
  query GetCountriesForDropdown($clientId: ID!, $dateFrom: String, $dateTo: String) {
    getCountryOriginSummary(clientId: $clientId, dateFrom: $dateFrom, dateTo: $dateTo) {
      country_code
      total_duties
      total_goods_value
    }
  }
`;

export const GET_MANUFACTURERS_FOR_DROPDOWN = gql`
  query GetManufacturers($dashboardVisibility: DashboardImportMetricsInput!) {
    dashboardVisibilityGetManufacturers(dashboardVisibility: $dashboardVisibility) {
      data {
        manufacturer
        manufacturerName
        tariffValue
        tariffDuty
        customValue
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_REPORT_DOWNLOAD_URL = gql`
  query GetReportDownloadUrl($reportId: ID!) {
    getReportDownloadUrl(reportId: $reportId) {
      data
    }
  }
`;

export const CREATE_TRADE_DATA_EXPORT = gql`
  mutation CreateTradeDataExport($input: TradeDataExportInput!) {
    createTradeDataExport(input: $input) {
      data
    }
  }
`;
